<div class="container-fluid px-0">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="rectangle">
        <div class="col-12 px-0 d-flex">
          <label class="title">Üye Ol</label>
        </div>
        <div class="col-12 px-0 d-flex ">
          <label class="description">Aşağıdaki alana size ait <span class="text-style">cep telefonu numaranızı girin.</span></label>
        </div>
        <div class="col-12 px-0 d-flex ">
          <mat-form-field class="input-style">
            <mat-label>Cep telefonu numaranızı girin</mat-label>
            <input placeholder="(590) 123 12 12" matInput>
          </mat-form-field>
        </div>
        <div class="col-12 d-flex">
          <button class="button-style"><span class="text-style">Devam Et</span></button>
        </div>
      </div>
    </div>
  </div>
</div>
